// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3FJWz","bigColWidth":"Table_bigColWidth__1Ey1X","biggerColWidth":"Table_biggerColWidth__21Urn","row":"Table_row__rDSLC","col":"Table_col__6p5lp"};